import { Flex, GlobalStatus, ProgressIndicator } from '@dnb/eufemia';
import { DEVELOPER_PORTAL_CONTENT_PREFIX } from '@portals/shared/common/contentPaths';
import { ContentDto } from '@portals/shared/portal/ContentDto';
import { type JSX } from 'react';
import useSWR from 'swr';

import { HeroPageGuide } from '@/components/HeroPageGuide';

export default function DeveloperPortalGuideContent({ contentSlug }: { contentSlug: string }): JSX.Element {
  const { data: content, isValidating: loading } = useSWR<ContentDto[]>(
    `/content${DEVELOPER_PORTAL_CONTENT_PREFIX}/${contentSlug}`,
  );

  if (loading || !content)
    return (
      <Flex.Horizontal justify="center">
        <ProgressIndicator />
      </Flex.Horizontal>
    );

  return content.length === 0 ? (
    <GlobalStatus
      hideCloseButton
      noAnimation
      show
      state="error"
      text="We can't find the content you're looking for. Please contact us or try again later."
      title="Oops! Something went wrong."
    />
  ) : (
    <HeroPageGuide content={content[0]!.blob.content} />
  );
}
